<div class="content-wrapped">
    <!-- Content -->
<div class="container-xxl flex-grow-1 container-p-y">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Solicitudes</h1>
    </div>

    <div class="row">
        <!-- Total -->
        <div class="col-xl-3 col-md-6 mb-4" (click)="getSolicitudes(0)" style="cursor: pointer;">
            <div class="card border-left-primary shadow h-100 py-2">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="text-xs font-weight-bold text-primary  mb-1">Solicitudes</div>
                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ countTotal }}</div>
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Pendientes -->
        <div class="col-xl-3 col-md-6 mb-4" (click)="getSolicitudes(1)" style="cursor: pointer;">
            <div class="card border-left-warning shadow h-100 py-2">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="text-xs font-weight-bold text-warning  mb-1">Solicitudes pendientes</div>
                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ countPendientes }}</div>
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-clock fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- En Proceso -->
        <div class="col-xl-3 col-md-6 mb-4" (click)="getSolicitudes(2)" style="cursor: pointer;">
            <div class="card border-left-info shadow h-100 py-2">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="text-xs font-weight-bold text-info  mb-1">Solicitudes en proceso</div>
                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ countEnProceso }}</div>
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-spinner fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Terminadas -->
        <div class="col-xl-3 col-md-6 mb-4" (click)="getSolicitudes(3)" style="cursor: pointer;">
            <div class="card border-left-success shadow h-100 py-2">
                <div class="card-body">
                    <div class="row no-gutters align-items-center">
                        <div class="col mr-2">
                            <div class="text-xs font-weight-bold text-success  mb-1">Solicitudes terminadas</div>
                            <div class="h5 mb-0 font-weight-bold text-gray-800">{{ countTerminadas }}</div>
                        </div>
                        <div class="col-auto">
                            <i class="fas fa-check-circle fa-2x text-gray-300"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card shadow mb-4">
        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">Listado de solicitudes</h6>
            <div>
                <mat-form-field appearance="outline" class="me-2" *ngIf="hasPermissions() && selectedRequests.size > 0 && this.statusSelected != 3">
                    <mat-label>Cambio de estado masivo</mat-label>
                    <mat-select [(ngModel)]="massiveStatus" (selectionChange)="changeMassiveStatus()">
                        <mat-option [value]="1">Pendiente</mat-option>
                        <mat-option [value]="2">En proceso</mat-option>
                        <mat-option [value]="3">Terminada</mat-option>
                    </mat-select>
                </mat-form-field>
        <button mat-raised-button color="primary"
           (click)="downloadExcel()"
            class="mb-2 me-2"
           
            matTooltip="Descargar listado"
            target="_blank"
          >
            <mat-icon>download</mat-icon>
            Descargar listado
        </button>
                <button *ngIf="this.statusSelected != 3" mat-raised-button color="primary" (click)="openAddEditDialog()">
                    <mat-icon>add</mat-icon>
                    Nueva solicitud
                </button>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-3">
                    <mat-form-field class="w-100">
                        <mat-label>
                            <mat-icon>search</mat-icon> Buscar
                        </mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ej. Título, responsable, etc.">
                    </mat-form-field>
                </div>
            </div>
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th [hidden]="this.statusSelected === 3" mat-header-cell *matHeaderCellDef>
                            <span >
                             <mat-checkbox *ngIf="hasPermissions()"  (change)="$event ? masterToggle() : null"
                                          [checked]="selectedRequests.size > 0 && isAllSelected()"
                                          [indeterminate]="selectedRequests.size > 0 && !isAllSelected()"
                                          [aria-label]="checkboxLabel()">
                             </mat-checkbox>
                            </span>

                        </th>
                        <td mat-cell *matCellDef="let row" [hidden]="this.statusSelected === 3">
                            <span>
                                <mat-checkbox *ngIf="hasPermissions()" (click)="$event.stopPropagation()"
                                (change)="$event ? toggleSelection(row) : null"
                                [checked]="selectedRequests.has(row.id)" [disabled]="row.status === 3"
                                [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </span>

                        </td>
                    </ng-container>

                    <!-- CHECK Column -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  </th>
                        <td mat-cell *matCellDef="let element">  </td>
                    </ng-container>

                    <!-- ID Column -->

                    <ng-container matColumnDef="id_code">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                    </ng-container>

                    <!-- Título Column -->
                    <ng-container matColumnDef="titulo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 110px;"> Solicitud </th>
                        <td mat-cell *matCellDef="let element"
                            (click)="openAddEditDialog(element)"
                            class="link-style"
                            [matTooltip]="element.titulo" 
                            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 110px;">
                            {{element.titulo}}
                        </td>
                    </ng-container>

                          <!-- Descripcion Column -->
                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 120px;"> Descripción </th>
                        <td mat-cell *matCellDef="let element" [matTooltip]="element.descripcion" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px;"> {{element.descripcion}} </td>
                    </ng-container>
                    <!-- Creador Column -->
                    <ng-container matColumnDef="nombre_creador">
                        <th  [hidden]="!hasPermissions()" mat-header-cell *matHeaderCellDef mat-sort-header> Solicitante </th>
                        <td  [hidden]="!hasPermissions()" mat-cell *matCellDef="let element"> {{element.nombre_creador}} </td>
                    </ng-container>

                    <!-- Responsable Column -->
                    <ng-container matColumnDef="nombre_responsable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Responsable </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre_responsable || 'No asignado'}} </td>
                    </ng-container>

                    <!-- Badges Column -->
                    <ng-container   matColumnDef="badges">
                        <th  [hidden]="!hasPermissions()" mat-header-cell *matHeaderCellDef> Etiquetas </th>
                        <td  [hidden]="!hasPermissions()" mat-cell *matCellDef="let element" style="min-width: 185px;">
                            <ng-container *ngIf="element.parsed_badges && element.parsed_badges.length > 0">
                                <mat-chip-list>
                                    <mat-chip [matTooltip]="element.parsed_badges[0]" style="text-overflow: ellipsis; max-width: 160px;"><span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px;">{{ element.parsed_badges[0] }}</span></mat-chip>
                                 <span *ngIf="element.parsed_badges.length > 1"
                                      class="badge-counter"
                                      [matTooltip]="element.parsed_badges.slice(1).join(', ')">
                                    +{{ element.parsed_badges.length - 1 }}
                                </span>
                                </mat-chip-list>

                            </ng-container>
                        </td>
                    </ng-container>

                    <!--Last interacion-->
                    <ng-container matColumnDef="last_interaction">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Últ. interacción</th>
                        <td mat-cell *matCellDef="let element"> {{element.last_interaction || 'Sin interacción'}} </td>
                    </ng-container>

                    <!--Last interacion-->
                    <ng-container matColumnDef="last_interaction_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header > Fecha últ. interacción</th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"> {{element.last_interaction_date ?  (element.last_interaction_date | date:'dd/MM/yyyy':"+0000") : '-'}} </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Estatus </th>
                        <td mat-cell *matCellDef="let element" style="margin-left: 5px;">
                            <!-- Vista normal (etiqueta) -->
                            <span *ngIf="editingStatusRowId !== element.id" 
                                  class="badge" 
                                  [ngClass]="{'badge-warning': element.status === 1, 'badge-info': element.status === 2, 'badge-success': element.status === 3}"
                                  (click)="startEditingStatus(element)"
                                  style="cursor: pointer;">
                                {{ getStatusName(element.status) }}
                            </span>
                            <mat-select #statusSelect *ngIf="editingStatusRowId === element.id" [value]="element.status" (selectionChange)="changeStatus(element, $event.value)" (openedChange)="!$event && cancelEditingStatus()">
                                    <mat-option [value]="1"><span class="badge badge-warning">Pendiente</span></mat-option>
                                    <mat-option [value]="2"><span class="badge badge-info">En Proceso</span></mat-option>
                                    <mat-option [value]="3"><span class="badge badge-success">Terminada</span></mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <!-- Created At Column -->
                    <ng-container matColumnDef="created_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha creación </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"> {{element.created_at | date:'dd/MM/yyyy': "+0000"}} </td>
                    </ng-container>

                    <!-- Estimated Date Column --> 
                    <ng-container matColumnDef="estimated_date">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha compromiso </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 5px;"> {{element.estimated_date ? (element.estimated_date | date:'dd/MM/yyyy':"+0000") : 'No definida'}} </td>
                    </ng-container>

                    <!-- Actions Column -->
                    <ng-container matColumnDef="actions" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef
                          style="min-width: 130px; margin-left: 3px; padding-left: 20px; background: #e7e7e7;"> Acciones </th>
                        <td mat-cell *matCellDef="let element" style="padding-left: 10px; background: #e7e7e7;">
                            <button mat-icon-button color="accent" matTooltip="Chat y registros" (click)="openHistory(element)">
                                <mat-icon>forum</mat-icon>
                            </button>
                           <button mat-icon-button color="warn" matTooltip="Eliminar" (click)="deleteRequest(element.id)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>
            <mat-paginator #paginator [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
</div>